import React, { useContext } from 'react';
import { trimmer } from '../helpers';
import { JobContext } from '../JobContext';
export var JobLocation = function JobLocation() {
  var _useContext = useContext(JobContext),
      prefix = _useContext.prefix,
      forceSmall = _useContext.forceSmall,
      employer = _useContext.employer,
      displayLocation = _useContext.displayLocation;

  return /*#__PURE__*/React.createElement("p", {
    className: "".concat(prefix, "__content__location")
  }, trimmer("".concat(employer.name).concat(displayLocation ? ", ".concat(displayLocation) : ''), 35, forceSmall));
};
JobLocation.displayName = "JobLocation";